import React from 'react';

const TermsOfUse: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-12 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">
          Terms of Use
        </h1>
        <div className="prose max-w-none">
          <p className="text-sm text-gray-500 italic mb-6">Last Updated: March 30, 2026</p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">1. Acceptance of Terms</h2>
          <p className="text-gray-600 mb-4">
            By accessing or using the Divorce Property Calculator website (“Site"), you agree to be bound by these Terms of Use (“Terms"). If you do not agree, do not use the Site.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">2. Service Description</h2>
          <p className="text-gray-600 mb-4">
            The Site provides an interactive tool that generates a preliminary estimate of how marital property might be divided in a divorce based on user‑provided information and general legal principles of selected states. The tool is for informational and educational purposes only.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">3. No Attorney-Client Relationship</h2>
          <p className="text-gray-600 mb-4">
            Your use of the Site does not create an attorney‑client relationship. The results are not legal advice and should not be relied upon as such. You are strongly encouraged to consult a licensed attorney in your state before making any legal decisions.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">4. User Obligations</h2>
          <p className="text-gray-600 mb-4">
            You represent that all information you provide is true, accurate, and complete to the best of your knowledge. You are responsible for maintaining the confidentiality of any payment details used on the Site.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">5. Payment and Refunds</h2>
          <p className="text-gray-600 mb-4">
            Access to the full calculation report requires a one‑time payment processed through Stripe. All sales are final; no refunds will be issued once the report has been delivered, except as required by applicable law.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">6. No Data Storage</h2>
          <p className="text-gray-600 mb-4">
            We do not store any personal or financial information you enter on the Site. Data entered is used only temporarily to generate your report and is deleted immediately after the report is delivered.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">7. Limitation of Liability</h2>
          <p className="text-gray-600 mb-4">
            To the fullest extent permitted by law, we disclaim all warranties, express or implied, including merchantability or fitness for a particular purpose. We shall not be liable for any direct, indirect, incidental, or consequential damages arising from your use of the Site or reliance on any output.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">8. Governing Law</h2>
          <p className="text-gray-600 mb-4">
            These Terms shall be governed by the laws of England and Wales, without regard to conflict of law principles, as our company is registered in the United Kingdom.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">9. Changes to Terms</h2>
          <p className="text-gray-600 mb-4">
            We may modify these Terms at any time. Your continued use of the Site after changes constitutes acceptance of the revised Terms.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;
